































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {GithubOrganization} from '@/model/resource/GithubOrganization'

@Component({})
export default class CDOrganizationInformation extends Vue {
  @Prop({type: GithubOrganization, required: true})
  selectedOrganization!: GithubOrganization
}
